import { runInAction, makeAutoObservable } from 'mobx';
import { documentHandler } from '../handlers/documentHandler';
import LoadingProgressStore from './LoadingProgressStore';

class DocumentStore {
  uploadDocumentStatus = false;
  uploadBulkLeadsStatus = false;
  documentDeleteStatus = false;
  documentsListByLead = [];
  documentDownloadFile = null;
  error = '';

  constructor() {
    makeAutoObservable(this);
  }

  async uploadDocumentToS3(payload) {
    LoadingProgressStore.toggleIsLoading(true);
    documentHandler
      .uploadDocumentToS3(payload)
      .then((response) => {
        runInAction(() => {
          this.uploadDocumentStatus = true;
        });
      })
      .catch((err) => {
        runInAction(() => {
          this.error = err;
        });
        console.error(err);
      })
      .finally(() => {
        runInAction(() => {
          LoadingProgressStore.toggleIsLoading(false);
          this.uploadDocumentStatus = false;
        });
      });
  }

  async uploadBulkLeads(payload) {
    LoadingProgressStore.toggleIsLoading(true);
    documentHandler
      .uploadBulkLeadsTemp(payload)
      .then((response) => {
        runInAction(() => {
          this.uploadBulkLeadsStatus = true;
        });
      })
      .catch((err) => {
        runInAction(() => {
          this.error = err;
        });
        console.error(err);
      })
      .finally(() => {
        runInAction(() => {
          LoadingProgressStore.toggleIsLoading(false);
          this.uploadBulkLeadsStatus = false;
        });
      });
  }

  async getLeadDocumentNamesByLeadId(leadId) {
    documentHandler
      .getLeadDocumentNamesByLeadId(leadId)
      .then((response) => {
        runInAction(() => {
          this.documentsListByLead = response.data.returnValue;
        });
      })
      .catch((err) => {
        runInAction(() => {
          this.error = err;
        });
        console.error(err);
      });
  }

  async deleteDocument(fileid) {
    LoadingProgressStore.toggleIsLoading(true);
    documentHandler
      .deleteDocument(fileid)
      .then((response) => {
        runInAction(() => {
          this.documentDeleteStatus = true;
        });
      })
      .catch((err) => {
        runInAction(() => {
          this.error = err;
        });
        console.error(err);
      })
      .finally(() => {
        this.documentDeleteStatus = false;
        LoadingProgressStore.toggleIsLoading(false);
      });
  }

  async downloadDocumentFromS3(documentId, fileName) {
    LoadingProgressStore.toggleIsLoading(true);
    documentHandler
      .downloadDocumentFromS3(documentId)
      .then((response) => {
        runInAction(() => {
          this.documentDownloadFile = {
            file: response.data,
            fileName,
          };
        });
      })
      .catch((err) => {
        runInAction(() => {
          this.error = err;
        });
        console.error(err);
      })
      .finally(() => {
        LoadingProgressStore.toggleIsLoading(false);
        runInAction(() => {
          this.documentDownloadFile = null;
        });
      });
  }
}

export default new DocumentStore();
